import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Thoughts, { ThoughtsContact } from "../components/thoughts"
import FooterLinks from "../components/footerLinks"
import thoughts from "../data/thoughts"

const ThoughtsPage = ({ data }) => {
  const { pageData } = data
  const { thoughts: thoughtsPage } = pageData.siteMetadata.pages

  return (
    <Layout showHeader={false}>
      <SEO
        title={thoughtsPage.title}
        description={thoughtsPage.description}
        pathname="/thoughts/"
        keywords={[
          "Rahul Vagadiya",
          "product thinking",
          "AI",
          "building products",
        ]}
      />
      <div className="thoughts-site">
        <nav className="thoughts-nav" aria-label="Primary navigation">
          <Link className="thoughts-nav__brand" to="/">
            Rahul Vagadiya
          </Link>
          <Link className="thoughts-nav__link" to="/">
            Home
          </Link>
        </nav>

        <header className="thoughts-hero">
          <h1>My thoughts on product, AI, and building.</h1>
          <p>{thoughtsPage.description}</p>
        </header>

        <Thoughts thoughts={thoughts} title={null} showExcerpt />
        <ThoughtsContact />

        <footer className="thoughts-footer">
          <Link className="thought-home-link" to="/">
            Back to home <span aria-hidden="true">→</span>
          </Link>
          <FooterLinks links={pageData.siteMetadata.dev.links} />
        </footer>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query ThoughtsPageQuery {
    pageData: site {
      siteMetadata {
        pages {
          home {
            name
            description
          }
          thoughts {
            title
            name
            description
          }
        }
        dev {
          links {
            name
            url
            filename
            tooltip
            icon
          }
        }
      }
    }
  }
`

export default ThoughtsPage
